import { Outlet, Route } from 'react-router-dom';
import PrivateRoute from '../../PrivateRoute/PrivateRoute';
import Scripts from './Scripts';
import Script from './Script/Script';
import AddScript from './AddScript/AddScript';

export const ScriptsRoutes = (
  <Route path="scripts" element={<Outlet />}>
    <Route
      index
      element={(
        <PrivateRoute roles={['Admin', 'Pharmacy', 'Rep']}>
          <Scripts />
        </PrivateRoute>
    )}
    />

    <Route
      path=":scriptId"
      element={(
        <PrivateRoute roles={['Admin', 'Pharmacy', 'Rep', 'Physician', 'Patient', 'Health']}>
          <Script />
        </PrivateRoute>
      )}
    />

    <Route
      path=":scriptId/edit"
      element={(
        <PrivateRoute roles={['Admin', 'Pharmacy', 'Rep']}>
          <AddScript />
        </PrivateRoute>
      )}
    />

    <Route
      path="add/:patientId"
      element={(
        <PrivateRoute roles={['Admin', 'Pharmacy', 'Rep']}>
          <AddScript />
        </PrivateRoute>
      )}
    />
  </Route>
);
